'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {
//   Link,
//  } from '../../components'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./PlanScorecardCompanyVideo.css');

var PlanScorecardCompanyVideo = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardCompanyVideo, _Component);

  function PlanScorecardCompanyVideo(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardCompanyVideo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardCompanyVideo.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardCompanyVideo)).call(this, props));

    _this.state = {
      videoId: _config2.default.companyVideoIds[props.shortName] || null
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardCompanyVideo, [{
    key: 'render',
    value: function render() {
      if (!this.state.videoId) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'media-react-player-wrap-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'media-react-player-wrap' },
          _react2.default.createElement(_reactPlayer2.default, {
            url: 'https://vimeo.com/' + this.state.videoId,
            volume: 0.5,
            config: {
              vimeo: {
                playerOptions: {
                  texttrack: 'en-US'
                }
              }
            }
          })
        )
      );
    }
  }]);
  return PlanScorecardCompanyVideo;
}(_react.Component), _class2.propTypes = {
  shortName: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardCompanyVideo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardCompanyVideo/PlanScorecardCompanyVideo.js
// module id = 1412
// module chunks = 0